import { render, staticRenderFns } from "./DOTS.vue?vue&type=template&id=0fb5f86a&scoped=true"
import script from "./DOTS.vue?vue&type=script&lang=js"
export * from "./DOTS.vue?vue&type=script&lang=js"
import style0 from "./DOTS.vue?vue&type=style&index=0&id=0fb5f86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb5f86a",
  null
  
)

export default component.exports